import { gql } from '@apollo/client';

import MEMBER_ATTESTATIONS_FULL_QUERY from './attestations';
import MEMBER_COMPUTED_FULL_QUERY from './computed';
import VALIDATION_ERRORS_QUERY from './validationErrors';

export const edeApplicationQuery = `
  coverageYear
  creatingDePartner
  submittingDePartner
  insuranceApplicationIdentifier
  applicationVersionNumber
  versionDateTime
  applicationCreationDateTime
  useCase
  creatingSystemId
  creatingSystemRole
  creatingUserId
  deletedIndicator
  currentVersionIndicator
  comments
  lastModifiedDateTime
  lastModifiedUserId
  creationOriginType
  applicationSubmissionDateTime
  submissionOriginType
  lastConsumerSubmissionDateTime
  copiedFromInsuranceApplicationIdentifier
  copiedFromInsuranceApplicationVersionNumber
  insuranceApplicationType
  applicationStatus
  attestations {
    application {
      requestingFinancialAssistanceIndicator
      contactMemberIdentifier
      spokenLanguageType
      writtenLanguageType
      coverageState
      contactInformation {
        email
        primaryPhoneNumber {
          type
          number
          ext
        }
        secondaryPhoneNumber {
          type
          number
          ext
        }
        mobileNotificationPhoneNumber
      }
      applicationAssistors {
        assistorLastName
        assistorMiddleName
        assistorFirstName
        assistorSuffix
        applicationAssistorType
        assistorNationalProducerNumber
        assistorOrganizationId
        assistorOrganizationName
      }
      applicationSignatures {
        applicationSignatureType
        applicationSignatureText
        applicationSignatureDate
      }
      legalAttestations {
        absentParentAgreementIndicator
        changeInformationAgreementIndicator
        medicaidRequirementAgreementIndicator
        renewEligibilityYearQuantity
        nonIncarcerationAgreementIndicator
        penaltyOfPerjuryAgreementIndicator
        renewalAgreementIndicator
        terminateCoverageOtherMecFoundAgreementIndicator
      }
      insuranceApplicationSecurityQuestionAnswer
      insuranceApplicationSecurityQuestionType
      contactMethod
      voterRegistrationAnswerType
    }
    household {
      familyRelationships {
        memberIdentifier
        subMemberIdentifier
        relationship
        familyRelationshipIndicator {
          resideTogetherIndicator
          caretakerRelativeIndicator
        }
      }
      legalRelationships {
        memberIdentifier
        subMemberIdentifier
        relationship
      }
      taxRelationships {
        memberIdentifier
        subMemberIdentifier
        relationship
      }
    }
    removedMembers
    members {
      ${MEMBER_ATTESTATIONS_FULL_QUERY}
    }
  }
  computed {
    application {
      multiTaxHouseholdIndicator
      bestSEP {
        status
        statusReason
        startDate
        endDate
        sepType
        associatedMemberIdentifiers
        coverage60DayBeforeCircumstanceChangeConfirmedIndicator
      }
      finalQhpEffectiveStartDate
      finalQhpEffectiveEndDate
      aptcEvent {
        ptcFplPercentage
        taxHouseholdAnnualIncomeAmount
        maxAPTCAmount
        slcspPremiumAmount
        slcspIdentifier
      }
      benchmarkPlanDataEvent {
        benchmarkPlans {
          benchmarkMemberIdentifier
          insurancePlanIdentifier
          insurancePlanName
          issuerName
          totalPremiumRate
          initialQhpEffectiveDate
        }
      }
    }
    taxHouseholds {
      memberIdentifier
      taxHouseHoldComposition {
        taxHouseHoldStatus
        taxHouseHoldStatusReason
        taxHouseholdMemberIdentifiers
      }
      annualIncome {
        incomeExplanationRequiredReasonType
        attestedAnnualTaxHouseholdIncomeAmount
        attestedAnnualTaxHouseholdIncomePercent
        annualIncomeStatus
        annualIncomeStatusReason
        incomeExplanationRequiredIndicator
        usedDocumentAnnualTaxIncomeAmountExplanationRequiredAmount
      }
    }
    variableDeterminations {
      creationDateTime
      samePlanAvailableForCicIndicator
      memberVariableDeterminations {
        memberIdentifier
        catastrophicEligibilityIndicator
        catastrophicEligibilityReasonType
        planMetalLevelRestrictionRuleType
        currentPlanOnlyIndicator
        planMetalLevelRestrictionRuleReasonType
        allowedPlanMetalLevelType
        lpaIndicator
      }
      coverageState
    }
    removedMembers
  }
  edeMembers {
    memberIdentifier
    attestations {
      ${MEMBER_ATTESTATIONS_FULL_QUERY}
    }
    computed {
      ${MEMBER_COMPUTED_FULL_QUERY}
    }
  }
  validationErrors {
    ${VALIDATION_ERRORS_QUERY}
  }
  lastUpdateMetadata {
    partnerId
    roleId
    sourceSystemName
    useCase
    userId
  }
`;

const EDE_APPLICATION_FULL_QUERY = gql`
  query EdeApplication($appID: ID!) {
    edeApplication(appID: $appID) {
      ${edeApplicationQuery}
    }
  }
`;

export default EDE_APPLICATION_FULL_QUERY;
